import { createFileRoute } from "@tanstack/react-router"

import { WallGraphic } from "@/components/wall/WallGraphic"
import { IntroContent } from "@/sections/layouts/IntroContent"

export const Route = createFileRoute("/$sessionId/_session/intro/wall")({
  component: IntroLocationRoute,
})

function IntroLocationRoute() {
  const { sessionId } = Route.useParams()

  return (
    <IntroContent
      aboveHeading={<WallGraphic type="WholeWall" />}
      activeStepIndex={3}
      numberOfSteps={5}
      heading={{ i18nKey: "intro.wall.heading" }}
      linkProps={{ to: "/$sessionId/intro/wallDetail", params: { sessionId } }}
      subheading={{
        i18nKey: "general.howTo",
      }}
      description={{
        i18nKey: "intro.wall.description",
        components: {
          uppercase: <span className="uppercase" />,
          bold: <span className="text-ic-primary font-bold" />,
        },
      }}
    />
  )
}
